<template>
  <section id="services" class="hw-section">
    <div class="hw-container">
      <p class="hw-kicker">Serviços</p>
      <h2 class="hw-title">O que construímos</h2>
      <p class="hw-lead">
        Do primeiro ecrã à infraestrutura, desenvolvemos produtos digitais à medida das vossas operações,
        sem modelos genéricos nem soluções que ficam a meio.
      </p>
      <div class="hw-services-grid">
        <article class="hw-card" v-for="(service, i) in services" :key="i">
          <div class="hw-icon">
            <v-icon color="#7ee8c4">{{ service.icon }}</v-icon>
          </div>
          <h3>{{ service.title }}</h3>
          <p>{{ service.text }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      services: [
        {
          icon: "mdi-layers-triple-outline",
          title: "Plataformas digitais",
          text: "Sistemas web personalizados para operações, clientes e dados. Arquitetura pensada para evoluir com o vosso negócio.",
        },
        {
          icon: "mdi-cellphone",
          title: "Aplicações móveis",
          text: "Aplicações iOS e Android intuitivas, com a vossa identidade e uma experiência pensada até ao último detalhe.",
        },
        {
          icon: "mdi-web",
          title: "Websites",
          text: "Sites rápidos, claros e pensados para converter, da presença institucional ao produto digital.",
        },
      ],
    };
  },
};
</script>
